<template>
  <div>
    <PageAllow controller="Requisitions" action="addViews" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRangeWithRadio
              v-model="options"
              type="datetime"
              show-radios
              :radios="datetimeRadios"
              deleteIcon
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="
                $permission.permissionAllow(
                  'Requisitions',
                  'getIntelligentDetails'
                )
              "
              small
              color="primary"
              class="elevation-1 ms-1"
              width="110px"
              :disabled="!showSelected.length"
              @click="submit()"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{ $t("AutoRequisition.create.title") }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="stock_order_code"
                  v-model="options.stock_order_code"
                  @text="stockOutsKeyWord = $event"
                  :label="$t('AutoRequisition.Fields.stockOutsKeyword_two')"
                />
              </v-col>
              <!-- 仓库 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherStock :stock-types="[0]" v-model="stockSelected" />
              </v-col>
              <!-- 客户 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherShops v-model="shopsSelected" />
              </v-col>
              <!-- 商品分类 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherMaterialCategory v-model="categorySelected" />
              </v-col>
              <!-- 商品 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherMaterials v-model="materialSelected" :materialCategories="(categorySelected) ? [categorySelected] : []" />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div class="mx-4 my-4">
        <v-data-table
          v-model="showSelected"
          id="purchase_from_order_table"
          :headers="headers"
          class="elevation-2 pa-4 mt-4"
          :items="stockOuts"
          show-select
          item-key="id"
          disable-sort
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :footer-props=footerProps
          :loading="loading"
        >
          <template v-slot:item.created="{ item }">
            {{ item.created | formatTime }}
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import StockOuts from "@/api/stock_outs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherMaterialCategory from "@/components/plugins/SearcherMaterialCategory";
import SearcherMaterials from "@/components/plugins/SearcherMaterials";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherShops from "@/components/plugins/SearcherShops";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  order_time_from: "",
  order_time_to: "",
  actual_time_from: "",
  actual_time_to: "",
  expect_time_from: "",
  expect_time_to: "",
  stock_order_code: "",
  category_code: "",
  material_ids: [],
  stock_ids: null,
  shop_ids: [],
  status: [2],
  cancel_flgs: [0],
  is_requested: 0,
  type: 1,
  auto_requisition: 1,
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherMaterialCategory,
    SearcherMaterials,
    SearcherStock,
    SearcherShops,
  },

  computed: {
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          replace: true,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.requisitions"),
          disabled: false,
          href: "/requisitions",
        },
        {
          text: i18n.t("AutoRequisition.title"),
          disabled: true,
          href: "/requisitions/auto-requisition",
        },
      ];

      return items;
    },

    headers() {
      var headers = [
        {
          text: i18n.t("AutoRequisition.Fields.stock_out_code"),
          align: "start",
          sortable: false,
          value: "stock_order_code",
        },
        {
          text: i18n.t("AutoRequisition.Fields.stock_out_obj_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "obj_name",
        },
        {
          text: i18n.t("AutoRequisition.Fields.order_code"),
          align: "start",
          value: "order_code",
        },
        {
          text: i18n.t("AutoRequisition.Fields.stock_name"),
          align: "start",
          sortable: false,
          value: "stock.name",
        },
        {
          text: i18n.t("AutoRequisition.Fields.created"),
          align: "start",
          value: "created",
        },
      ];

      return headers;
    },

    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("StockOrderOUT.Fields.created_time"),
      },
      {
        key: "order",
        text: i18n.t("StockOrderOUT.Fields.order_time"),
      },
      {
        key: "actual",
        text: i18n.t("StockOrderOUT.Fields.actual_time"),
      },
      {
        key: "expect",
        text: i18n.t("StockOrderOUT.Fields.expect_time"),
      }
    ],

    footerProps() {
      let props = Object.assign({}, i18n.t("$config.footer-props"));
      props.itemsPerPageOptions = [...props.itemsPerPageOptions, -1];
      return props;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    stockOuts: [],
    paging: {},
    showSelected: [],
    options: JSON.parse(
      sessionStorage.getItem("auto-requisition-options")
        ? sessionStorage.getItem("auto-requisition-options")
        : JSON.stringify(defaultOptions)
    ),
    stockOutsKeyWord: "",
    categorySelected: null,
    materialSelected: [],
    stockSelected: null,
    shopsSelected: null,
    loading: false,
  }),

  mounted() {
    this.$commonUtils
      .loadOptions("auto-requisition", [
        "stockSelected",
        "shopsSelected",
        "categorySelected",
        "materialSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "categorySelected":
                this.categorySelected = selected.value;
                break;
              case "materialSelected":
                this.materialSelected = selected.value;
                break;
              case "stockSelected":
                this.stockSelected = selected.value;
                break;
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  methods: {
    resetSearch() {
      this.stockOutsKeyWord = "";
      this.categorySelected = null;
      this.materialSelected = [];
      this.stockSelected = null;
      this.shopsSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.stock_order_code].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        stock_order_code: this.stockOutsKeyWord,
      });
    },
    getStockOutsFromAPI() {
      this.loading = true;
      let options = Object.assign({}, this.options, {
        itemsPerPage: this.options.itemsPerPage == -1 ? this.$consts.limitAll : this.options.itemsPerPage,
      })
      StockOuts.fetch(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stockOuts = response.data.stock_outs;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    submit() {
      if (this.showSelected.length) {
        var stockOrderIds = this.showSelected.map((s) => {
          return s.id;
        });
        this.$router.push({
          path: "/requisitions/auto-requisition-create",
          query: {
            stockOrderIds: stockOrderIds,
            type: this.$route.query.type,
            minus_current_count: this.options.minus_current_count
          },
        });
      }
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getStockOutsFromAPI();
        sessionStorage.setItem(
          "auto-requisition-options",
          JSON.stringify(this.options)
        );
      },
    },
    categorySelected: {
      handler() {
        this.options.category_code = this.categorySelected
          ? this.categorySelected.code
          : null;
        sessionStorage.setItem(
          "auto-requisition-categorySelected",
          JSON.stringify(this.categorySelected)
        );
      },
    },
    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
          ? this.materialSelected.map((e) => {
            return e.id;
          })
          : [];
        sessionStorage.setItem(
          "auto-requisition-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
    stockSelected: {
      handler() {
        this.options.stock_ids = this.stockSelected
          ? this.stockSelected.id
          : null;
        sessionStorage.setItem(
          "auto-requisition-stockSelected",
          JSON.stringify(this.stockSelected)
        );
      },
    },
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
          ? this.shopsSelected.map((alliance) => {
            return alliance.id;
          })
          : [];
        sessionStorage.setItem(
          "auto-requisition-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },


  },
};
</script>